// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"8cb2bfd2","410":"c4961123","503":"a3107c73","973":"aa1b221a"}[chunkId] + ".chunk.js";
};